import { render, staticRenderFns } from "./DynamicImageProperties.vue?vue&type=template&id=638eee94"
import script from "./DynamicImageProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicImageProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports